import * as a from "react";
import o from "../lib/IconBase.es.js";
import i from "../defs/SealWarning.es.js";
const n = a.forwardRef((r, e) => /* @__PURE__ */ a.createElement(o, { ref: e, ...r, weights: i }));
n.displayName = "SealWarningIcon";
const m = n;
export {
  n as CircleWavyWarningIcon,
  m as SealWarning,
  n as SealWarningIcon
};
